export default "__VITE_ASSET__bc4135ea__"